import type {
  EventPrefix,
  GoogleTagManagerEventDetails,
} from "@/features/analytics/models";
import {
  EVENT_PREFIX,
  EVERFLOW_CUSTOM_EVENT_ID,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import {
  triggerCustomerIoCheckoutPageViewed,
  triggerEverflowEvent,
  triggerGoogleTagManagerTracking,
} from "@/features/analytics/triggers";
import { categoriesToGoogleTagManagerProducts } from "@/features/analytics/utils";
import type { OnboardingUser } from "@/features/onboarding/models";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { calculateTotal } from "@/features/products/utils";
import { COUNTRY, CURRENCY } from "@/shared/models";
import { QUORA_EVENT } from "../models";
import { triggerQuoraTracking } from "../triggers";

interface TrackCheckoutInitiatedParams {
  user: OnboardingUser;
  selectedCategories: CategoryWithSelectedProduct[];
  eventPrefix?: EventPrefix;
}

export const trackCheckoutInitiated = ({
  user,
  selectedCategories,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackCheckoutInitiatedParams) => {
  triggerQuoraTracking({
    event: QUORA_EVENT.ADD_PAYMENT_INFO,
  });
  triggerEverflowEvent({
    eventId: EVERFLOW_CUSTOM_EVENT_ID.INITIATE_CHECKOUT,
    email: user.email,
    amount: calculateTotal(selectedCategories),
  });
  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.BEGIN_CHECKOUT}`,
    user_data: {
      user_id: user.code,
      email: user.email,
      first_name: user.firstName,
      last_name: user.lastName,
      state: user.state,
      country: COUNTRY.US,
      user_agent: navigator.userAgent,
    },
    ecommerce: {
      currency: CURRENCY.USD,
      value: calculateTotal(selectedCategories),
      items: categoriesToGoogleTagManagerProducts(selectedCategories),
    },
  });
  triggerCustomerIoCheckoutPageViewed({
    user,
    categories: selectedCategories,
    eventPrefix,
  });
};
